<app-slider />
<!-- <app-stripe-setup-intents></app-stripe-setup-intents> -->
<div class="container_productList" rel="preload" as="image">
  <h2 class="title_secctions">Ultimos lanzamientos</h2>
  @if (productList?.length <= 0) {
    <fa-icon [icon]="iconSpinner" size="4x" animation="spin" [style]="{ color: 'white' }"></fa-icon>
  }
  @if (productList?.length >= 1) {
    <div class="container_item" [class.reset_grid]="productList.length <= 0">
      @for (item of productList; track $index) {
        @if ($index < 4) {
          <div class="container_product">
            <div class="item_product">
              <div class="item_image">
                <!-- <div class="badge">
                            <span> Preventa</span>
                        </div> -->
                @if (item.status === 4) {
                  <div class="badge badge__onRequest">
                    <span> Sobre Pedido</span>
                  </div>
                }
                @if (item.status === 3) {
                  <div class="badge badge__transit">
                    <span> En Transito</span>
                  </div>
                }
                @if (item.status === 2) {
                  <div class="badge">
                    <span> Preventa</span>
                  </div>
                }
                @if (item.stock === 0) {
                  <div class="badge badge__soldOut">
                    <span> Sold Out</span>
                  </div>
                }
                <a [routerLink]="['/product', item.permalink]">
                  <!-- <a href="product/{{item.permalink}}"> -->
                  @for (im of item.image; track $index) {
                    <!-- @if ( im.size>500) { -->
                    <img [src]="im.src | imgProductSize: size" [alt]="item.name" loading="eager" width="356" height="445" [class.soldOut]="item.stock === 0" [id]="size" />
                    <!-- <img [ngSrc]="im.src | imgProductSize:size" [alt]="item.name" eager
                                [class.soldOut]="item.stock===0" /> -->
                    <!-- } -->
                  }
                </a>
              </div>

              <div class="item_desctiptions">
                <p>
                  <a [routerLink]="['/product', item.permalink]">
                    <!-- <a href="product/{{item.permalink}}"> -->
                    {{ item.name }}
                  </a>
                </p>
              </div>
              <div class="item_price">
                <!-- @for (price of item.price_currency; track $index) {
            <a [routerLink]="['/product', item.permalink]">
              <p>{{ price.regular_price | currency }}</p>
            </a>
            } -->

                @for (price of item.price_currency; track $index) {
                  @if (price.sale_price) {
                    <a [routerLink]="['/product', item.permalink]">
                      <p class="mb-2 sale">{{ price.regular_price | currency }} {{ price.currency }}</p>
                      <p class="mb-2 ofert">{{ price.sale_price | currency }} {{ price.currency }}</p>
                    </a>
                  } @else {
                    <a [routerLink]="['/product', item.permalink]">
                      <p class="mb-2">{{ price.regular_price | currency }} {{ price.currency }}</p>
                    </a>
                  }
                }
              </div>
            </div>
          </div>
        }
      }
    </div>
  }
  @if (productList?.length >= 1) {
    <a [routerLink]="['/category', 'pre-venta']" class="btn btn__default--blank"> Ver más </a>
  }
</div>
<!-- <div class="container_banner "> 
    <h2 class="title_secctions">Artis Release</h2>
    <a href="category/abaoabaoabao">
        <img src="https://d2r31p9h1pd7zy.cloudfront.net/assets/img/medusasa.webp" />
    </a>

</div> -->
<app-category />
<a href="https://discord.gg/NYgYyZDH" target="_blank" aria-label="discord">
  <img src="https://d2r31p9h1pd7zy.cloudfront.net/assets/img/discord.webp" class="discord" alt="discord channel" />
</a>

<div class="container_productList no-bg">
  <h2 class="title_secctions">Productos en stock</h2>
  @if (productListStock?.length <= 0) {
    <fa-icon [icon]="iconSpinner" size="4x" animation="spin" [style]="{ color: 'white' }"></fa-icon>
  }
  @if (productListStock?.length >= 1) {
    <div class="container_item" [class.reset_grid]="productListStock.length <= 0">
      @for (item of productListStock; track $index) {
        @if ($index < 4) {
          <div class="container_product">
            <div class="item_product">
              <div class="item_image">
                <!-- <div class="badge">
                                <span> Preventa</span>
                            </div> -->
                @if (item.status === 4) {
                  <div class="badge badge__onRequest">
                    <span> Sobre Pedido</span>
                  </div>
                }
                @if (item.status === 3) {
                  <div class="badge badge__transit">
                    <span> En Transito</span>
                  </div>
                }
                @if (item.status === 2) {
                  <div class="badge">
                    <span> Preventa</span>
                  </div>
                }
                @if (item.stock === 0) {
                  <div class="badge badge__soldOut">
                    <span> Sold Out</span>
                  </div>
                }
                <a [routerLink]="['/product', item.permalink]">
                  <!-- <a href="product/{{item.permalink}}"> -->
                  @for (im of item.image; track $index) {
                    <!-- @if ( im.size>500) { -->
                    <img [src]="im.src | imgProductSize: size" [alt]="item.name" loading="lazy" [class.soldOut]="item.stock === 0" [id]="size" />
                    <!-- } -->
                  }
                </a>
              </div>

              <div class="item_desctiptions">
                <p>
                  <a [routerLink]="['/product', item.permalink]">
                    <!-- <a href="product/{{item.permalink}}"> -->
                    {{ item.name }}
                  </a>
                </p>
              </div>
              <div class="item_price">
                @for (price of item.price_currency; track $index) {
                  <!-- <p>{{ price.regular_price | currency }}</p> -->

                  @if (price.sale_price) {
                    <a [routerLink]="['/product', item.permalink]">
                      <p class="mb-2 sale">{{ price.regular_price | currency }} {{ price.currency }}</p>
                      <p class="mb-2 ofert">{{ price.sale_price | currency }} {{ price.currency }}</p>
                    </a>
                  } @else {
                    <a [routerLink]="['/product', item.permalink]">
                      <p class="mb-2">{{ price.regular_price | currency }} {{ price.currency }}</p>
                    </a>
                  }
                }
              </div>
            </div>
          </div>
        }
      } @empty {
        <p>No hay productos a mostrar.</p>
      }
    </div>
  }
  @if (productListStock?.length >= 1) {
    <a [routerLink]="['/category', 'stock']" class="btn btn__default"> Ver más </a>
  }
</div>
<!-- <a [routerLink]="[ '/category', 'stock']" class="btn btn__default">
    Ver productos</a>
</div> -->

<app-newsletter />
